import { cn } from '@/lib/utils'

export const CollectionContainer = ({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) => {
  return (
    <section className={cn('bg-light px-5 py-9 lg:px-15', className)}>
      {children}
    </section>
  )
}
